<template>
  <div class="reg-form">
    <h3 class="reg-title">当前选择：{{ this.regName }}</h3>
    <div class="">
      <van-field v-model="username" label="姓名" placeholder="请输入姓名" />
      <van-field v-model="phone" type="tel" label="手机号" placeholder="请输入手机号" maxlength="11" />
      <van-field
        v-model="code"
        maxlength="6"
        autocomplete="off"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button size="small" type="primary" v-if="count>=90" @click="getCode" native-type="button">发送验证码</van-button>
          <van-button size="small" type="primary" disabled native-type="button" v-else>倒计时 {{count}} s</van-button>
        </template>
      </van-field>
      <van-cell is-link readonly clickable title="选择地区" :value="address" placeholder="请选择所在地区" @click="bindShow" />
      <!--选择省市区-->
      <van-popup v-model="showArea" position="bottom" :style="{ height: '40%' }">
        <van-area :area-list="areaList" @confirm="onAreaConfirm" @cancel="bindCancel" />
      </van-popup>
      <van-field v-model="password" type="password" label="登陆密码" placeholder="6-18位数字、字母或特殊符号" minlength="6" />
<!--      <div class="reg-login"><router-link to="/login">已有账号，立即登录</router-link></div>-->

      <div class="address-list">
        <div class="address-title">收货地址</div>
        <van-cell is-link @click="showPopup">
          <div class="address-def">
            <p class="p1">{{ addressInfo.name }} {{ addressInfo.tel }}<span v-if="addressInfo.status == 1">默认</span></p>
            <p class="p2">{{ addressInfo.province }}{{ addressInfo.city }}{{ addressInfo.county }}{{ addressInfo.detail }}</p>
          </div>
        </van-cell>
        <van-popup
          v-model="show"
          closeable
          position="bottom"
          :style="{ height: '50%' }"
        >
          <van-address-list
            v-model="chosenAddressId"
            :list="addressData"
            default-tag-text="默认"
            @add="onAdd"
            @edit="onEdit"
            @select="clickItem"
          />
        </van-popup>
      </div>

    </div>
    <van-button type="default" class="reg-btn" @click="regForm">确认提交</van-button>
    <div class="reg-msg" v-if="regType == 1" >区域注册成功后公司会在一小时内与您电话联系核对信息，请注意电话接听。</div>
    <wxNoShare />
  </div>
</template>

<script>
  import { Button, RadioGroup, Radio, Form, Field, Area, Popup, Cell, AddressList } from 'vant'
  import AeraInfo from "../../assets/area/area.js"

  export default {
    components: {
      [Button.name]: Button,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Form.name]: Form,
      [Field.name]: Field,
      [Area.name]: Area,
      [Popup.name]: Popup,
      [Cell.name]: Cell,
      [AddressList.name]: AddressList,
    },
    name: 'Genre',
    data () {
      return {
        username: '',
        phone: '',
        code: '',
        verification_key: '',
        password: '',
        count: 90,
        timer: null,
        regName: '区域',
        regType: '1',
        areaList: [], //引用地区信息
        showArea: false,
        address: '', //地区值
        arrArea: [], //存放地区数组
        show: false,
        chosenAddressId: 0,
        addressData: [],
        addressInfo: {
          name: '请填写收货地址',
          tel: '',
          province: '',
          city: '',
          county: '',
          detail: '',
          status: 0,
        },
      }
    },
    created: function () {
      this.regType = this.$route.params.type
      if(this.regType == 2){
        this.regName = '门店'
      }
      this.getCity()

      if(process.env.NODE_ENV === 'production') {
        this.addressList()
      }
    },
    destroyed() {
      clearInterval(this.timer);
    },
    methods: {
      getCity() {
        this.$api.get('settings/area', {reg_type: this.regType}, r=>{
          this.areaList = r.data
        })
      },
      formatter(value) {
        // 过滤输入的数字
        return value.replace(/\d/g, '');
      },
      //获取验证码
      getCode() {
        if (!this.phone.length) {
          this.$toast('请输入手机号');
        } else if (!this.common.verifyPhone(this.phone)) {
          // !/^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/.test(this.phone)
          this.$toast('请输入正确的手机号码');
          return
        } else {
          // 发送验证码
          this.$api.post('verificationCodes', {'phone':this.phone}, r=>{
            if(r.success === 1){
              this.$toast(r.message)
              this.verification_key = r.data.key
              this.timer = setInterval(()=>{
                this.count --
                if(this.count<=0){
                  clearInterval(this.timer);
                  this.count = 90;
                }
              },1000)
            }
          })
        }
      },
      regForm() {
        if(this.username.trim() == ''){
          this.$toast('姓名不能为空')
          return
        }
        if(this.phone.trim() == ''){
          this.$toast('手机号不能为空')
          return
        }
        if(!this.common.verifyPhone(this.phone)){
          this.$toast('请输入正确的手机号码');
          return
        }
        if(this.code.trim() == ''){
          this.$toast('短信验证码不能为空')
          return
        }
        if(this.password.trim() == ''){
          this.$toast('密码不能为空')
          return
        }
        if(this.password.length < 6){
          this.$toast('密码长度不能小于六位')
          return
        }
        if(this.address.trim() == ''){
          this.$toast('请选择地区')
          return
        }
        if(this.addressInfo.province === '' || this.addressInfo.detail === ''){
          this.$toast('请填写收货地址')
          return
        }
        let self = this
        let weixin_openid = localStorage.getItem('weixin_openid')
        let nickname = localStorage.getItem('nickname')
        let avatar = localStorage.getItem('avatar')
        let hid = localStorage.getItem('hid')
        // 提交注册
        this.$api.post('users', {members_grade_id:this.regType, name: this.username, phone: this.phone, verification_code: this.code, verification_key: this.verification_key, password:this.password, address:this.address, hid:hid, weixin_openid:weixin_openid, nickname:nickname, avatar:avatar, addressInfo: this.addressInfo}, r=>{
          if(r.success == 1) {
            localStorage.removeItem('hid')
            /*
            this.$toast({'message':'注册成功', onOpened:function(){
                self.$router.push({name: 'login'})
            }})
            */
            this.$toast({'message':'注册成功', onOpened:function(){
              self.$router.push({name:'paymentPay', query:{id: r.data.order_id}})
            }})

          }
        })
      },
      bindShow(){
        this.showArea= true;
      },
      bindCancel(){
        this.showArea= false;
      },
      //地区选择
      onAreaConfirm(val) {
        //console.log(val)
        this.showArea = false
        this.arrArea = val
        var addrInfo = val[0].name + '-' + val[1].name + '-' + val[2].name
        this.address = addrInfo
      },
      onAdd() {
        this.$router.push({name:'addressAddEdit', query:{type:1}});
      },
      onEdit(item, index) {
        this.$router.push({name:'addressAddEdit', query:{id:item.id, type:1}});
      },
      showPopup() {
        this.show = true
      },
      clickItem(item, index) {
        this.addressInfo.name = item.name
        this.addressInfo.tel = item.tel
        this.addressInfo.province = item.province
        this.addressInfo.city = item.city
        this.addressInfo.county = item.county
        this.addressInfo.detail = item.detail
        this.addressInfo.status = item.status
        this.show = false
      },
      addressList() {
        this.$api.get('address', null, r=>{
          this.addressData = r.data
          for(let i=0; i<r.data.length; i++){
            if(r.data[i].isDefault){
              this.chosenAddressId = r.data[i].id
              this.addressInfo.name = r.data[i].name
              this.addressInfo.tel = r.data[i].tel
              this.addressInfo.province = r.data[i].province
              this.addressInfo.city = r.data[i].city
              this.addressInfo.county = r.data[i].county
              this.addressInfo.detail = r.data[i].detail
              this.addressInfo.status = r.data[i].status
            }
          }
        })
      }
    },
  }
</script>

<style scoped>
  .reg-form{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: fixed;
  }
  .reg-title{
    text-align: center;
    font-weight: normal;
    font-size: 18px;
    color:#646566;
    margin-top:30px;
  }
  .reg-btn{
    background: #ED6B0D;
    color:#fff;
    width: 80%;
    border-radius: 25px;
    margin: 25px auto 0;
    display: inherit;
  }
  .reg-msg{
    font-size: 14px;
    padding:15px;
    color: #b4b1bc;
    line-height: 25px;
  }
  .reg-login{
    font-size: 12px;
    text-align: right;
    margin-top:15px;
    margin-right:10px;
  }
  .reg-login a{
    color:#ED6B0D;
  }
  .address-list{
    margin-top:3%;
    overflow: hidden;
  }
  .address-title{
    font-weight: bold;
    padding:2% 4% 0;
    font-size: 14px;
    color:#ed6a0c;
  }
  .address-def .p1{
    font-weight: bold;
    font-size: 13px;
  }
  .address-def .p1 span{
    background: #ee0a24;
    color:#ffffff;
    font-size: 12px;
    margin-left: 4px;
    border-radius: 10px;
    padding: 2px 7px;
  }
  .address-def .p2{
    font-size: 14px;
  }
  .address-def p{
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/registers/form.vue